export interface UserData {
    userId: string;
    userName: string;
    userCreateDate: string;
    userLastModifiedDate: string;
    enabled: boolean;
    userStatus: string;
    emailVerified: string;
    email: string;
    givenName: string;
    familyName: string;
    preferredUserName: string;
    tempPassword?: string;
    phoneNumber: string;
    sfId: string;
    jobTitle: string;
    jobLocation: string;
    account: {
        accountId: string;
        accountName: string;
    }
    accountId: string;
    accountName: string;
    suppressWelcomeEmail: boolean;
    linkedInLink: string;
    notes: string;
}

type Partial<T> = { [p in keyof T]?: T[p]; };
type WithOptional<T, K extends keyof T> = Omit<Partial<T>, K> & Pick<T, K>;

export type PartialUserData = WithOptional<UserData, 'email'>;
